import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { InvestmentGeographicAllocationClient } from "../../../../../../../../Wrap/Api/Transformation/InvestmentGeographicAllocation";
import { AssetClassType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { InsightsDispatcher, InvestmentRegionAllocationDispatcher } from "../Store/Variable";
import { InvestmentSectorAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentSectorAllocationModel";
import { InvestmentSectorAllocationClient } from "../../../../../../../../Wrap/Api/PortfolioValuation/InvestmentSectorAllocation";
import { InvestmentAssetClassAllocationClient } from "../../../../../../../../Wrap/Api/PortfolioValuation/InvestmentAssetClassAllocation";
import { InvestmentRegionAllocationClient } from "../../../../../../../../Wrap/Api/PortfolioValuation/InvestmentRegionAllocation";
import { InvestmentRegionAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentRegionAllocationModel";
import { ModelPortfolioAssetRegionAllocationClient } from "../../../../../../../../Wrap/Api/PortfolioValuation/ModelPortfolioAssetRegionAllocation";
import { InvestmentRegionGroupClient } from "../../../../../../../../Wrap/Api/PortfolioValuation/InvestmentRegionGroup";
import { TopTenHoldingsClient } from "../../../../../../../../Wrap/Api/PortfolioAnalysis/PortfolioDetails/TopTenHoldings";
import { TopTenHoldingModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/PortfolioDetails/TopTenHoldingModel";
import { InvestmentGeographicAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentGeographicAllocationModel";

export class InsightsAction {
    public static getGeographicAllocation(
        hierarchyIds: string[],
        asAt: Date,
        callback?: (val: Array<InvestmentGeographicAllocationModel>) => void
    ) {
        const selectDate = JsonDateParser.toJsonDateNoOffset(asAt);
        const client = new InvestmentGeographicAllocationClient();
        const promise = client.get(hierarchyIds, selectDate, AssetClassType.Tier1);
        promise.onSuccess((result) => {
            if (result) {
                callback(result);
            }

            InvestmentRegionAllocationDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {
            InvestmentRegionAllocationDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getTopTenData(
        asAt: Date,
        hierarchyIds: string[],
        includeExternal: boolean,
        useConversionView: boolean,
        callBack?: (val: Array<TopTenHoldingModel>) => void
    ): void {
        const selectDate = JsonDateParser.toJsonDateNoOffset(asAt);
        const client = new TopTenHoldingsClient();
        const promise = client.get(selectDate, hierarchyIds, includeExternal, useConversionView);
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getInvestmentSectorAllocation(
        hierarchyIds: string[],
        assetClassType: AssetClassType,
        asAt: Date,
        callBack?: (val: InvestmentSectorAllocationModel) => void
    ): void {
        const selectDate = JsonDateParser.toJsonDateNoOffset(asAt);
        const client = new InvestmentSectorAllocationClient();
        const promise = client.get(hierarchyIds, assetClassType, selectDate);
        promise.onSuccess((res) => {
            if (callBack) {
                callBack(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getInsightAssetAllocation(
        hierarchyIds: string[],
        assetClassType: AssetClassType,
        asAt: Date,
        callback?
    ) {
        const selectDate = JsonDateParser.toJsonDateNoOffset(asAt);
        const client = new InvestmentAssetClassAllocationClient();
        const promise = client.get(hierarchyIds, assetClassType, selectDate);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getInvestmentRegionAllocation(
        hierarchyIds: string[],
        assetClassType: AssetClassType,
        asAt: Date,
        callback?: (val: InvestmentRegionAllocationModel[]) => void
    ) {
        const selectDate = JsonDateParser.toJsonDateNoOffset(asAt);
        const client = new InvestmentRegionAllocationClient();
        const promise = client.get(hierarchyIds, selectDate, assetClassType);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getAssetAreaGroup(callback?: (val: InvestmentRegionAllocationModel[]) => void) {
        const client = new InvestmentRegionGroupClient();
        const promise = client.get();
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }

            InsightsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
        });

        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getModelPortfolioAssetRegionAllocation(
        modelFundInstrumentCode: string,
        asAt: Date,
        callback?: (val: InvestmentRegionAllocationModel[]) => void
    ) {
        const selectDate = JsonDateParser.toJsonDateNoOffset(asAt);
        const client = new ModelPortfolioAssetRegionAllocationClient();
        const promise = client.get(modelFundInstrumentCode, selectDate, AssetClassType.Tier1);
        promise.onSuccess((res) => {
            if (callback) {
                callback(res);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }
}
